import PATH from '@/config/paths/PATH';
import useUser from '@/redux/hooks/useUser';
import React from 'react';
import { Navigate } from 'react-router-dom';

function AuthGuard({ children, allowed = [], redirectTo = PATH.UNAUTHORIZED, ...rest }) {
  const { user } = useUser();

  if (!user.isAuthenticated) {
    return <Navigate to={PATH.LOGIN} replace />;
  }

  if (!allowed || allowed.length === 0) {
    return children;
  }

  if (allowed.length > 0 && !allowed.includes(user.role_id)) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
}

export default AuthGuard;
